module.exports = __webpack_public_path__ + "img/33545-009.6dc0e459.jpg";